// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4m9qE","skeleton-animation":"styles_skeleton-animation__rDASz"};